export default __webpack_public_path__ + "static/Terrestrial Assemblage_Pressemitteilung-c7d351ceed9483dff5d9f010797059b1.pdf";